import { render, staticRenderFns } from "./InfoDialogs.vue?vue&type=template&id=7976e9e6&"
import script from "./InfoDialogs.vue?vue&type=script&lang=ts&"
export * from "./InfoDialogs.vue?vue&type=script&lang=ts&"
import style0 from "./InfoDialogs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports